<template>
  <div>
    <v-container fluid>
      <v-toolbar dark class="header-title">
        <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
          $t("managementGPTModelNode")
        }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
      </v-toolbar>
      <v-card class="card2" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-container style="margin-top: 1rem">
            <v-row>
              <v-col cols="6" class="mt-3">
                <span
                  style="
                    font-size: 20px;
                    font-weight: 700;
                    background: -webkit-linear-gradient(#9747ff, #5179ef);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                  "
                >
                  {{ editAction ? $t("update") : $t("create") }}
                  <span style="font-size: 20px; font-weight: 500"
                    >{{ $t("gptModelInternal") }}</span
                  >
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  :label="$t('nodeName')"
                  v-model="GPTModelNode.nodeName"
                  outlined
                ></v-text-field>
              </v-col>
              <v-expansion-panels multiple flat v-model="panel">
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="">
                    <template v-slot:actions>
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </template>
                    <span class="header">{{ $t("prompt") }}</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          :label="$t('prompt')"
                          outlined
                          counter
                          auto-grow
                          rows="30"
                          :maxlength="4000"
                          :messages="$t('_charTokenHint')"
                          v-model="GPTModelNode.prompt"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="">
                    <template v-slot:actions>
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </template>
                    <span class="header">{{ $t("example") }} 1</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          :label="$t('role') + ' 1'"
                          v-model="GPTModelNode.role1"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          outlined
                          :label="$t('content') + ' 1'"
                          v-model="GPTModelNode.content1"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="">
                    <template v-slot:actions>
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </template>
                    <span class="header">{{ $t("example") }} 2</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          :label="$t('role') + ' 2'"
                          v-model="GPTModelNode.role2"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          outlined
                          :label="$t('content') + ' 2'"
                          v-model="GPTModelNode.content2"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="">
                    <template v-slot:actions>
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </template>
                    <span class="header">{{ $t("example") }} 3</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          :label="$t('role') + ' 3'"
                          v-model="GPTModelNode.role3"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          outlined
                          :label="$t('content') + ' 3'"
                          v-model="GPTModelNode.content3"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="">
                    <template v-slot:actions>
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </template>
                    <span class="header">{{ $t("example") }} 4</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          :label="$t('role') + ' 4'"
                          v-model="GPTModelNode.role4"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          outlined
                          :label="$t('content') + ' 4'"
                          v-model="GPTModelNode.content4"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                  <v-expansion-panel-header expand-icon="">
                    <template v-slot:actions>
                      <v-icon class="icon">mdi-chevron-down</v-icon>
                    </template>
                    <span class="header">{{ $t("example") }} 5</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          :label="$t('role') + ' 5'"
                          v-model="GPTModelNode.role5"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-textarea
                          outlined
                          :label="$t('content') + ' 5'"
                          v-model="GPTModelNode.content5"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
            <v-row>
              <v-col cols="12" justify="end" align="end">
                <v-btn
                  class="white--text mt-3"
                  style="
                    margin-left: 1em;
                    border-radius: 25.342px;
                    background: #faa91b;
                    width: 89.863px;
                  "
                  to="/GPTModelInternal"
                  >{{ $t("back") }}</v-btn
                >
                <v-btn
                  class="white--text mt-3"
                  style="
                    margin-left: 1em;
                    border-radius: 25.342px;
                    background: #9747ff;
                    width: 89.863px;
                  "
                  @click="Save()"
                  >{{ $t("save") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-flex>
        <br />
        <br />
        <br />
      </v-card>
    </v-container>
    <v-overlay :value="dialog">
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          {{ $t("loadingpleasewait") }}
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import call from "../api/call";
import checkPermissionTwo from "@/api/function.js";
const LogTrace = checkPermissionTwo;
export default {
  name: "GPTModelNodeDetail",
  mixins: [checkPermissionTwo, LogTrace],
  inject: ["flagNav", "FontColorTitle"],
  data: () => ({
    props: ["id"],
    panel: [0],
    checkbox1: false,
    EditdialogUser: false,
    Adddialog: false,
    dialog: false,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    value: null,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    loading: true,
    editAction: false,
    options: {},
    groupList: null,
    groupList2: null,
    groupList3: null,
    groupList4: null,
    GroupList: [],
    GPTModelNode: {
      modelNodeID: null,
      nodeName: null,
      prompt: null,
      role1: null,
      content1: null,
      role2: null,
      content2: null,
      role3: null,
      content3: null,
      role4: null,
      content4: null,
      role5: null,
      content5: null,
    },
    searchNodeName: "",
    isSearch: false,
    isFirst: true,
    menusDDL: [
      { MenuName: "User Management" },
      { MenuName: "Menu Management" },
      {
        MenuName: "Calendar",
      },
    ],
    menus: [
      {
        id: 0,
        MenuName: "User Management",
        Submenus: [
          { id: 11, SubmenuName: "Users" },
          { id: 22, SubmenuName: "User Group" },
          { id: 33, SubmenuName: "Permission Management" },
        ],
      },
      {
        id: 1,
        MenuName: "Menu Management",
      },
      {
        id: 2,
        MenuName: "Calendar",
      },
      {
        id: 3,
        MenuName: "Log",
      },
    ],
    headers: [],
    images: {
      edit: require("@/assets/edit1.png"),
      delete: require("@/assets/delete1.png"),
    },
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
    },
  },
  methods: {
    Get(id) {
      this.dialog = true;
      this.loading = true;
      call.GetGPTModelNodeById(
        id,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.Edit(dataResponse.data);
          }
          this.dialog = false;
        },
        (errorResource) => {
          this.dialog = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Save() {
      this.dialog = true;
      try {
        if (!this.editAction) {
          call.AddGPTModelNode(
            this.GPTModelNode,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                this.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.$router.push("/GPTModelInternal");
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              this.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else if (this.editAction) {
          call.UpdateGPTModelNode(
            this.GPTModelNode,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                this.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.$router.push("/GPTModelInternal");
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              this.Adddialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Edit(item) {
      this.editAction = true;
      this.GPTModelNode.modelNodeID = item.model_NodeID;
      this.GPTModelNode.nodeName = item.nodeName;
      this.GPTModelNode.prompt = item.prompt;
      this.GPTModelNode.role1 = item.role1;
      this.GPTModelNode.content1 = item.content1;
      this.GPTModelNode.role2 = item.role2;
      this.GPTModelNode.content2 = item.content2;
      this.GPTModelNode.role3 = item.role3;
      this.GPTModelNode.content3 = item.content3;
      this.GPTModelNode.role4 = item.role4;
      this.GPTModelNode.content4 = item.content4;
      this.GPTModelNode.role5 = item.role5;
      this.GPTModelNode.content5 = item.content5;

      this.EditdialogUser = true;
    },
    Clear() {
      this.GPTModelNode.modelNodeID = null;
      this.GPTModelNode.nodeName = null;
      this.GPTModelNode.prompt = null;
      this.GPTModelNode.role1 = null;
      this.GPTModelNode.content1 = null;
      this.GPTModelNode.role2 = null;
      this.GPTModelNode.content2 = null;
      this.GPTModelNode.role3 = null;
      this.GPTModelNode.content3 = null;
      this.GPTModelNode.role4 = null;
      this.GPTModelNode.content4 = null;
      this.GPTModelNode.role5 = null;
      this.GPTModelNode.content5 = null;
    },
    isSubstring: function (text = "") {
      if (text.length > 60) {
        return text.substring(0, 60) + "...";
      }
      return text;
    },
  },
  mounted() {
    this.GetDate();
    if (this.$route.query.id) {
      this.Get(this.$route.query.id);
    }
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.icon {
  order: 0;
}

.header {
  order: 1;
  font-weight: 700;
}
.v-expansion-panel-header {
  padding: 0;
}
.v-text-field :deep(label) {
  font-size: 0.9375rem;
}
</style>
